export const AGREEMENT_URL =
  'https://s3.eu-central-1.amazonaws.com/a.beatly.com/production/original_posts/042e1aab-273b-4702-8a99-2d8de969d5fa/20231201+-+Beatly+AB+-+Terms+and+Conditions.pdf';

export const PLANNER_PRODUCTION_URL = 'https://planner.beatly.com';
export const PLANNER_STAGING_URL = 'https://planner.staging.beatly.com';

/**
 * Gets the appropriate planner URL from environment variable
 * @returns The planner URL for the current environment
 */
export const getPlannerUrl = (): string => {
  return process.env.NEXT_PUBLIC_PLANNER_APP_URL || PLANNER_STAGING_URL;
};

/**
 * Gets the planner URL with JWT token for authentication
 * @param jwtToken - The JWT token for authentication
 * @returns The planner URL with JWT parameter
 */
export const getPlannerUrlWithJwt = (jwtToken: string): string => {
  const plannerUrl = getPlannerUrl();
  return `${plannerUrl}?jwt=${encodeURIComponent(jwtToken)}`;
};

/**
 * Gets the planner URL with draft parameter and JWT token for editing a campaign plan
 * @param draftId - The draft ID to edit
 * @param jwtToken - The JWT token for authentication
 * @returns The planner URL with draft and JWT parameters
 */
export const getPlannerUrlWithDraft = (draftId: string, jwtToken: string): string => {
  const plannerUrl = getPlannerUrl();
  return `${plannerUrl}?draft=${encodeURIComponent(draftId)}&jwt=${encodeURIComponent(jwtToken)}`;
};
